<div class="welcome-content">
  <div class="dashboard-hero mb-4">
    <div class="dashboard-hero-text">
      <h1 class="mb-1">{{ greeting }}<ng-container *ngIf="loginService.loggedInUser?.name as name">, {{ name
          }}</ng-container> 👋</h1>
      <p
        class="text-muted mb-0"
        i18n="@@welcomeIntro"
      >Willkommen in deinem persönlichen Bereich — hier findest du alle deine Tools, Trainings und Freigaben auf einen
        Blick.</p>
      <div
        class="home-message mt-3"
        *ngIf="homeMessage"
      >
        <div
          class="home-message-title"
          i18n="@@welcomeCurrentMessage"
        >Aktuelle Meldung</div>
        <div
          class="home-message-body"
          [innerHTML]="homeMessage"
        ></div>
      </div>
    </div>
  </div>

  <div class="mb-3">
    <h3
      class="mb-3"
      i18n="@@welcomeToolsHeading"
    >Deine Tools</h3>
    <app-tools-and-trainings></app-tools-and-trainings>
  </div>

  <p-card
    class="dashboard-section-block"
    *ngIf="this.serviceStatementVkcs.length > 0"
  >
    <ng-template pTemplate="header">
      <div
        class="p-3 fw-bold"
        i18n="@@welcomeStatements"
      >Kontoauszüge</div>
    </ng-template>
    <div class="container">
      <div
        *ngFor="let vkc of this.serviceStatementVkcs"
        class="flex flex-wrap mb-1"
      >
        <div class="flex-1">{{vkc.name}}</div>
        <div class="flex-1 text-end">
          <button
            pButton
            size="small"
            class="ri ri-download-2-line"
            (click)="this.faqService.downloadServiceStatement(vkc.crm_id)"
          ></button>
        </div>
      </div>
    </div>
  </p-card>
</div>
